import { connect } from 'react-redux'
import { StyledSubHeading } from 'components/headings'
import ShippingAddressForm from 'registry/forms/shipping-address-form'
import ModalManager from 'registry/components/modal-manager'
import { reset } from 'redux-form'

import { setActiveModal, saveShippingAddress } from 'registry/actions'
import {
  CONFIRM_SHIPPING_ADDRESS,
  RECOMMEND_SHIPPING_ADDRESS,
} from 'registry/constants'
import { SYSTEM_ERROR_KEY } from 'shared/constants'
import { parseErrors } from 'lib/api-utils'

const ShippingAddress = ({ onSubmitFail, onSubmitSuccess }) => (
  <div>
    <StyledSubHeading>Shipping Address</StyledSubHeading>
    <ShippingAddressForm
      showCancelButton={false}
      onSave={(values, dispatch) => {
        values.userConfirmed = false
        return dispatch(saveShippingAddress(values))
      }}
      onSubmitFail={onSubmitFail}
      onSubmitSuccess={onSubmitSuccess}
    />
    <ModalManager />
  </div>
)

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmitSuccess: () => {
    dispatch(reset('shippingAddressForm'))

    PubSub.publish(BLConstants.FLASH_MESSAGE, {
      variant: 'success',
      message: 'Your shipping address has been updated!',
    })
  },
  onSubmitFail: (resp) => {
    const { address, recommendedAddress, fieldErrors } = resp
    if (address) {
      const modalProps = {
        enteredAddress: {
          streetAddress1: address.address1,
          streetAddress2: address.address2,
          ...address,
        },
        fieldErrors,
        recommendedAddress,
        onEdit: () => dispatch(setActiveModal(null)),
      }

      const modalForm = recommendedAddress
        ? RECOMMEND_SHIPPING_ADDRESS
        : CONFIRM_SHIPPING_ADDRESS

      dispatch(setActiveModal(modalForm, modalProps))
    } else {
      const error = parseErrors(resp)
      const message = error[SYSTEM_ERROR_KEY]
      const variant = 'danger'

      PubSub.publish(BLConstants.FLASH_MESSAGE, { variant, message })
    }
  },
})

export default connect(null, mapDispatchToProps)(ShippingAddress)
